import { useNavigate } from "react-router-dom";
import { Check, ArrowRight, PenLine, Feather, BookOpen, Eye, Download } from "lucide-react";

const STEPS = [
  { key: "memories", label: "Save memories", icon: PenLine },
  { key: "polish", label: "Polish your stories", icon: Feather },
  { key: "chapters", label: "Build your chapters", icon: BookOpen },
  { key: "review", label: "Review your book", icon: Eye },
  { key: "download", label: "Download or print", icon: Download },
];

const ACTIONS = [
  { text: "Add your first memory", to: "/answer" },
  { text: "Polish a memory into a story", to: "/memories" },
  { text: "Build your first chapter", to: "/story" },
  { text: "Read your memoir so far", to: "/book", state: { read: true } },
  { text: "Finish and download your book", to: "/book" },
];

export function JourneyIndicator({ progress, chapters = 0, compact = false }) {
  const navigate = useNavigate();
  const memories = progress?.memories || 0;
  const stories = progress?.stories || 0;
  const chapterCount = chapters || progress?.chapters || 0;

  const done = [
    memories > 0,
    stories > 0,
    chapterCount > 0,
    false,
    false,
  ];
  let current = done.findIndex((d) => !d);
  if (current === -1) current = STEPS.length - 1;
  const action = ACTIONS[current];

  return (
    <div data-testid="journey-indicator" className="bg-white rounded-3xl border border-line p-5 sm:p-6 animate-fade-up">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <h3 className="font-serif text-lg text-charcoal">Your memoir journey</h3>
        <button
          data-testid="journey-next-action"
          onClick={() => navigate(action.to, action.state ? { state: action.state } : undefined)}
          className="inline-flex items-center gap-2 bg-coral hover:bg-coraldark text-white px-4 py-2 rounded-full font-semibold text-sm transition-colors"
        >
          {action.text} <ArrowRight size={15} />
        </button>
      </div>
      <ol className="mt-5 flex flex-col sm:flex-row sm:items-start gap-3 sm:gap-2">
        {STEPS.map((s, i) => {
          const isDone = done[i];
          const isCurrent = i === current;
          const Icon = s.icon;
          return (
            <li key={s.key} data-testid={`journey-step-${s.key}`} className="flex sm:flex-col sm:flex-1 items-center sm:items-center gap-3 sm:gap-2 sm:text-center">
              <span
                className={`w-9 h-9 rounded-full flex items-center justify-center shrink-0 transition-colors ${
                  isDone ? "bg-teal text-cream" : isCurrent ? "bg-coral text-white" : "bg-cream2 text-subtle border border-line"
                }`}
              >
                {isDone ? <Check size={17} /> : <Icon size={16} />}
              </span>
              <span className={`text-sm sm:text-xs leading-tight ${isCurrent ? "text-charcoal font-semibold" : isDone ? "text-teal" : "text-subtle"}`}>
                {s.label}
              </span>
            </li>
          );
        })}
      </ol>
    </div>
  );
}
